const EDIT_RESERVATION_ALLOWED_UPDATE_FIELDS = new Set([
  "cancellation_reason",
  "check_in_time",
  "check_out_time",
  "payment_status",
  "room_id",
  "special_requests",
  "status",
  "updated_by",
]);

const normalizeNullableString = (value) =>
  value == null || String(value).trim() === "" ? null : String(value).trim();

const normalizeComparableValue = (field, value) => {
  if (field === "room_id") {
    const normalized = normalizeNullableString(value);
    if (normalized == null) return null;
    const numericId = Number(normalized);
    return Number.isFinite(numericId) ? numericId : normalized;
  }

  if (field === "check_in_time" || field === "check_out_time") {
    const normalized = normalizeNullableString(value);
    if (normalized == null) return null;
    const match = normalized.match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!match) return normalized;
    return match[3] && match[3] !== "00"
      ? `${match[1]}:${match[2]}:${match[3]}`
      : `${match[1]}:${match[2]}`;
  }

  if (field === "status" || field === "payment_status") {
    return String(value ?? "").trim().toLowerCase();
  }

  if (
    field === "special_requests" ||
    field === "cancellation_reason" ||
    field === "updated_by"
  ) {
    return value == null ? "" : String(value);
  }

  return value;
};

const normalizePayloadValue = (field, value) => {
  if (field === "room_id") {
    return normalizeNullableString(value) == null ? null : value;
  }
  return value;
};

export const buildReservationUpdatePayload = (
  formData = {},
  originalFormData = null
) => {
  if (!originalFormData || typeof originalFormData !== "object") return {};

  const payload = Object.entries(formData).reduce((result, [field, value]) => {
    if (
      EDIT_RESERVATION_ALLOWED_UPDATE_FIELDS.has(field) &&
      normalizeComparableValue(field, value) !==
        normalizeComparableValue(field, originalFormData[field])
    ) {
      result[field] = normalizePayloadValue(field, value);
    }
    return result;
  }, {});

  return payload;
};

export const getReservationWorkflowBusinessUnitError = ({
  activeBusinessUnitId,
  reservationBusinessUnitId,
} = {}) => {
  const activeId = Number(activeBusinessUnitId);
  if (!Number.isInteger(activeId) || activeId <= 0) {
    return "Select an active business unit before changing this reservation.";
  }

  const reservationId = Number(reservationBusinessUnitId);
  if (!Number.isInteger(reservationId) || reservationId <= 0) {
    return "The reservation business unit could not be determined. Reload the reservation and try again.";
  }

  if (reservationId !== activeId) {
    return "This reservation belongs to another business unit. Switch to that business unit before changing it.";
  }

  return "";
};

export const buildReservationStudioUrl = ({
  reservationGroupId,
  businessUnitId,
}) => {
  if (!reservationGroupId || !businessUnitId) return null;

  const params = new URLSearchParams({
    mode: "view",
    business_unit_id: String(businessUnitId),
  });

  return `/reservation-group/${encodeURIComponent(reservationGroupId)}?${params.toString()}`;
};

export const buildRatesPricesUrl = ({
  reservationGroupId,
  businessUnitId,
  reservationId,
}) => {
  if (!reservationGroupId || !businessUnitId || !reservationId) return null;

  const params = new URLSearchParams({
    mode: "view",
    business_unit_id: String(businessUnitId),
    open_action: "rates_prices",
    reservation_id: String(reservationId),
  });

  return `/reservation-group/${encodeURIComponent(reservationGroupId)}?${params.toString()}`;
};
